import { useEffect } from 'react';
import Animated, {
  Easing,
  useAnimatedStyle,
  useReducedMotion,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';
import { StyleSheet } from 'react-native-unistyles';

export default function CountdownFill({ durationMs }: { durationMs: number }) {
  const progress = useSharedValue(0);
  const reduceMotion = useReducedMotion();

  useEffect(() => {
    progress.set(0);
    if (!reduceMotion) {
      progress.set(
        withTiming(1, { duration: durationMs, easing: Easing.linear }),
      );
    }
  }, [durationMs, progress, reduceMotion]);

  const animatedStyle = useAnimatedStyle(() => ({
    width: `${(1 - progress.get()) * 100}%`,
  }));

  return (
    <Animated.View
      pointerEvents="none"
      accessible={false}
      aria-hidden={true}
      style={[styles.fill, animatedStyle]}
    />
  );
}

const styles = StyleSheet.create((theme) => ({
  fill: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    top: 0,
    backgroundColor: theme.colors.surface,
    opacity: 0.5,
  },
}));
